<template>
	<div class="wf-component wf-group-pois-menu">
		<ul class="wf-list" :class="['wf-list-count-' + count]">
			<li @click="back()" class="wf-list-item list-header" :style="'background-color:'+ headerColor">
				<div class="wf-item-content" v-if="group">
					<label class="header-title" v-html="group.getName(language)"></label>
					<label class="close-btn">X</label>
				</div>
			</li>
			<li class="wf-list-item" v-touch:tap="onClick(poi)" :class='{"wf-active": currentPOI && poi.id == currentPOI.id}' v-for="poi in getPOIs" :key='poi.id' v-html="poi.getName(language)"></li>
		</ul>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'GroupPOIsMenu',
	props: {
		group: {
			type: Object,
			default: null
		},
		parentName: {
			type: String,
			default: '',
		},
		headerColor: {
			type: Object,
			default: null,
		},
		currentPOI: {
			type: Object,
			default: null
		}
	},
	data () {
		return {
			count: 0
		}
	},
	computed: {
		...mapState('wf', ['language']),
		getPOIs() {
			if (this.group && this.group.pois) {
				let arr = this.group.pois.slice(0);
				arr = arr.filter(p => p.getShowInMenu());
				this.count = arr.length;
				return arr.sort((a, b) => {
					return a.getName(this.language).localeCompare(b.getName(this.language));
				});
			}
			else {
				this.count = 0;
				return [];
			}
		},
		currentGroupName () {
			return this.group ? this.group.getName(this.language) : '';
		}
	},
	methods: {
		onClick (poi) {
			return () => {
				this.$emit('clicked', poi);
			};
		},
		back () {
			this.$store.dispatch('setTab', 'groups');
        },
		getGroupColor(group) {
            return "background-color:" + this.group.getColor();
        },
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.wf-group-pois-menu {
		user-select: none;
		overflow: auto;
	}

	.wf-group-pois-menu .wf-list {
		margin: 0;
        padding: 0;
    }

    .wf-group-pois-menu .wf-list-item {
		    list-style: none;
            padding: 0;
            height: 6rem;
            font-size: 1.2rem;
            padding: 0rem 1.4rem;
            border-bottom: 1px solid lightgray;
            background-color: #e3e3e3;
            display: flex;
            align-items: center;
    }
    .wf-group-pois-menu .list-header .wf-item-content {
		width: 100%;
		display: flex;
		justify-content: space-between;

	}

	.wf-group-pois-menu .list-header .wf-item-content .header-title {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.wf-group-pois-menu .list-header .wf-item-content .close-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 4rem;
		height: 4rem;
	}
    .wf-group-pois-menu .wf-list-header:before {
        background-image: none;
    }
    
</style>
